const state = {
  addons: null
}

const getters = {
  addons: state => state.addons
}

const mutations = {
  SET_ADDONS (state, addons) {
    const { list } = addons
    state.addons = list
  }
}

export default {
  state,
  getters,
  mutations
}
